import React from 'react';

/**
 * FAQ schema is now in public/index.html as static JSON-LD
 * for guaranteed crawlability without JavaScript (Google Rich Results Test friendly).
 *
 * This component is kept as a no-op for backwards compatibility.
 * To update the FAQ schema, edit public/index.html.
 */
const FAQSchema = () => null;

export default FAQSchema;
